export default {"src":"/_next/static/media/FinancialGroup-1_vertical.58723777.svg","height":534,"width":87};